import Color from 'color';
import React, { FunctionComponent, useContext } from 'react';
import ReactLoaders, { LoaderType } from 'react-loaders';
import styled from 'styled-components';
import Text from './Text';
import colors from '../colors.json';
import ProductColorContext from '../contexts/product-color';

const StyledLoader = styled(ReactLoaders)<{
  color: string;
  height: string | number;
}>`
  ${({ height }) => `
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: ${typeof height === 'number' ? `${height}px` : height};
    align-self: center;
    .loader-inner {
      // For "ball-beats"
      transform: scale(0.7) translateY(0.25rem);

      // For "line-spin-fade-loader"
      // transform: scale(0.6) translate(0.6rem, 0.6rem);
    }
  `}
`;

interface LoaderProps {
  type?: LoaderType;
  color?: string;
  className?: string;
  active?: boolean;
  showMessage?: boolean;
  message?: string;
  height?: string | number;
}

interface AppLoaderType extends FunctionComponent<LoaderProps> {
  Error?: any;
}

const Loader: AppLoaderType = ({
  type = 'ball-beat',
  color: incomingColor = colors.primary[450],
  active = true,
  showMessage = false,
  message = 'Please wait...',
  height = '1.5rem',
  ...restProps
}: LoaderProps) => {
  const color = useContext(ProductColorContext) || incomingColor;
  return (
    <div className="flex flex-col items-center justify-center flex-1">
      <StyledLoader
        {...restProps}
        type={type}
        active={active}
        height={height}
        color={Color(color)
          .darken(0.5)
          .toString()}
      />
      {showMessage && <Text className="mt-4">{message}</Text>}
    </div>
  );
};

export default Loader;
